import { create } from 'zustand';

import AppConfig from '../config/AppConfig';
import BackEndConnection from '../dal/BackEndConnection';

const ResourceTypeStore = create((set) => ({
    resourceTypes: null,
    resourceType: null,
    currentPage: 1,
    pageSize: 9,

    updateAttribute: (attributeName, newValue) => {
        set((state) => {
            state.resourceType[attributeName] = newValue;
            return { resourceType: state.resourceType };
        });
    },

    resetResourceType: () => {
        set((state) => {
            return { resourceType: {} };
        });
    },

    loadAll: (pageSize, currentPage, successCallback, errorCallback) => {
        const payload = { pageSize: pageSize, currentPage: currentPage };
        const url = AppConfig.HOST_URL + 'resourceType/loadAll';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => ({
                    resourceTypes: data.results,
                    bears: state.bears + 2,
                }));
            },
            successCallback,
            errorCallback,
        );
    },

    load: (id, successCallback, errorCallback) => {
        const payload = { id: id };
        const url = AppConfig.HOST_URL + 'resourceType/load';

        return BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => ({ resourceType: data }));
            },
            successCallback,
            errorCallback,
        );
    },

    create: (data, successCallback, errorCallback) => {
        const payload = { jsonStr: JSON.stringify(data) };
        var url = AppConfig.HOST_URL + 'resourceType/create';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    },

    update: (data, successCallback, errorCallback) => {
        const payload = { jsonStr: JSON.stringify(data) };
        var url = AppConfig.HOST_URL + 'resourceType/update';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    },

    delete: (id, successCallback, errorCallback) => {
        const payload = { id: id };
        var url = AppConfig.HOST_URL + 'resourceType/delete';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    },
}));

export default ResourceTypeStore;
